export class VkAdsPixel {

    constructor() {
        this.init();
    }

    init() {
        window._tmr = window._tmr || [];
        return window._tmr;
    }

    push(query) {
        window._tmr.push(query);
    }

    productPageView(product) {
        this.push(Object.assign(this.getQueryTemplate(), {
            value: parseFloat(product.price),
            goal: 'viewProduct',
            params: {product_id: product.id}
        }));
    }

    orderThankyouPageView(basket) {
        let ids = [];
        basket.forEach(product => {
            ids.push(product.id);
        });
        this.push(Object.assign(this.getQueryTemplate(), {
            goal: 'purchase',
            value: 'VALUE',
            params: {product_id: ids}
        }));
    }

    basketItemAdd(product) {
        this.push(Object.assign(this.getQueryTemplate(), {
            value: parseFloat(product.price),
            goal: 'addToCart',
            params: {product_id: product.id}
        }));
    }

    productAddToFavorite(product) {
        this.push(Object.assign(this.getQueryTemplate(), {
            value: parseFloat(product.price),
            goal: 'addToWishlist',
            params: {product_id: product.id}
        }));
    }

    getQueryTemplate() {
        return {
            id: '3464578',
            type: 'reachGoal',
        }
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/vk-ads-pixel.js